import { useState } from 'react'
import { MyIcon } from '~/components/ui/MyIcon'
import { observer } from 'mobx-react'
import Lightbox from 'yet-another-react-lightbox'
import 'yet-another-react-lightbox/styles.css'
import classNames from 'classnames'

import styles from './QuickPreview.module.css'
import { AI_QUICK_PAGE_SIZE } from '~/configs'
import { to400Image } from '~/utils'

interface Props {
  data: string[]
}

const NoLoginQuickPreivew = ({ data }: Props) => {
  const [product, setProduct] = useState<string>(data[0])

  // lightbox
  const [lightboxOpen, setlightboxOpen] = useState(false)
  const [lightboxIndex, setLightboxIndex] = useState(0)
  const lightboxImages = data.map(item => {
    return {
      src: item,
    }
  })
  const handleFullScreen = () => {
    const index = data.indexOf(product)
    setLightboxIndex(index)
    setlightboxOpen(true)
  }

  const BigPic = () => {
    const arr = (product || '').split('.')
    const wh = arr[arr.length - 2]
    const [w = 0, h = 0] = wh.split('×')
    console.log(w, h)
    return (
      <div className="w-full h-[584px]">
        {product && (
          <div
            className="w-full rounded-lg overflow-hidden relative"
            style={{
              background: `url(${product}) no-repeat center center / 100% 100%`,
            }}
          >
            <div
              className="w-full h-[584px] flex items-center justify-center"
              style={{
                backdropFilter: 'blur(200px)',
              }}
            >
              <div
                className="relative max-w-[584px]"
                style={{
                  height: Math.min(
                    Math.max(Math.floor((584 * Number(h)) / Number(w)), 0),
                    584
                  ),
                }}
              >
                <img
                  className="w-full h-full block object-contain"
                  style={{
                    backdropFilter: 'blur(200px)',
                  }}
                  src={product}
                  alt=""
                />
                <div className="absolute left-2 bottom-2 bg-neutral-50/50 rounded-full flex items-center text-neutral-800 p-1 text-xs">
                  <img
                    src="/images/ai/mark.png"
                    alt=""
                    className="w-3 h-3 inline-block"
                  />
                  &nbsp;无界AI优秀作品
                </div>
              </div>
            </div>

            <div
              className="w-8 h-8 flex items-center justify-center absolute
      top-2 right-2 bg-neutral-50/50 rounded-lg cursor-pointer"
              onClick={handleFullScreen}
            >
              <MyIcon
                icon="fullscreen"
                className="text-neutral-800 text-[24px]"
              />
            </div>
          </div>
        )}
      </div>
    )
  }

  return (
    <div className="w-[632px]">
      <div className="w-full overflow-hidden flex-col items-center justify-center">
        <BigPic />
        <div className="w-full h-3 bg-neutral-100"></div>
      </div>

      {/* 预览图 */}
      <div className="flex flex-wrap justify-start gap-1">
        {data.slice(0, AI_QUICK_PAGE_SIZE).map(item => {
          return (
            <div
              key={item}
              className={classNames(
                'w-[155px] h-[155px] cursor-pointer rounded-lg overflow-hidden bg-neutral-200 relative',
                {
                  'border-2 border-solid border-neutral-500': product === item,
                },
                styles.item
              )}
              onClick={() => {
                setProduct(item)
              }}
            >
              <img
                src={to400Image(item)}
                alt=""
                className="w-[155px] h-[155px] mb-1 rounded-lg object-cover"
              />
            </div>
          )
        })}
      </div>

      <Lightbox
        open={lightboxOpen}
        close={() => setlightboxOpen(false)}
        index={lightboxIndex}
        slides={lightboxImages.slice()}
        carousel={{
          finite: false,
          preload: 2,
          imageFit: 'contain',
        }}
        animation={{ fade: 250, swipe: 500 }}
      />
    </div>
  )
}

export default observer(NoLoginQuickPreivew)
